import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { RecipientModalComponent } from '../recipient-modal/recipient-modal.component';
import { MailDestinataireInput } from 'src/app/shared/models/iCourrier/post/mail-destinataire-input';
import moment from 'moment';
import * as async from 'async';
import * as _ from 'underscore';
import { MailDestinatairePInput } from 'src/app/shared/models/iCourrier/post/mail-destinataire-p-input';
import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from 'src/app/shared/services/data.service';
import { ActionResponseModalComponent } from '../../ACTIONS/action-response-modal/action-response-modal.component';
import { ActionCreateModalComponent } from '../../ACTIONS/action-create-modal/action-create-modal.component';
import { Router } from '@angular/router';
import { CModeChoiceModalComponent } from 'src/app/components/modals/c-mode-choice-modal/c-mode-choice-modal.component';
import { TranslateService } from '@devinforius/i-essentials';
import { UsersService } from 'src/app/shared/services/users.service';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { ConfigDto, ContactDto, GroupsGlobalDto, MailRecipientDetailsDto } from 'src/app/shared/interfaces';
import { GetMailRecipientsUtils } from 'src/app/utils/getMailRecipients.utils';
import { ContactsGlobalService } from 'src/app/shared/services/contacts-global.service';
import { ActionsService } from 'src/app/shared/services/actions.service';
import { RecipientsService } from 'src/app/shared/services/recipients.service';
import { MailsRightsService } from 'src/app/shared/services/mails-rights.service';
import { MeRightMail } from 'src/app/shared/models/iCourrier/me/right-mail-id';
import { ActionStatutDTO } from 'src/app/shared/interfaces/actions/action-statut-dto.interface';
import { MailDestinataire, MailRecipientDeleteDTO } from 'src/app/shared/models/mails/mail-destinataire';
import { Mail } from 'src/app/shared/models/mails/mail';
import { Cols } from 'src/app/shared/models/cols';
import { AssetsCalendarFr } from 'src/app/shared/models/calendar-fr';
import { GroupsService } from 'src/app/shared/services/groups.service';
import { RecipientModalOnCloseDatas } from 'src/app/shared/models/recipient-modal';
import { UserInfo } from 'src/app/shared/models/iCourrier/me/user-info';
import { ActionTypesDTO } from 'src/app/shared/interfaces/actions/action-types-dto.interface';
import { Action } from 'src/app/shared/models/action';
import { ConfigService } from 'src/app/shared/services/config.service';
import { catchError, forkJoin, of } from 'rxjs';

interface JustifyOptionInterface {
  icon: string;
  state: string;
}

@Component({
  selector: 'app-courrier-create-recipients',
  templateUrl: './courrier-create-recipients.component_v2.html',
  styleUrls: ['./courrier-create-recipients.component.scss'],
})
export class CourrierCreateRecipientsComponent implements OnChanges {
  public justifyOptions: JustifyOptionInterface[] = [
    { icon: 'bi bi-view-list', state: 'list' },
    { icon: 'bi bi-table', state: 'table' },
  ];
  public valueJustifyOption: JustifyOptionInterface = { icon: 'bi bi-view-list', state: 'list' };

  @Input() set services(
    value: {
      label: string;
      value: number;
      parentId: number;
      name: string;
      key: string;
      selectable: boolean;
      children: [];
      description: string;
      email: string;
    }[]
  ) {
    if (value.length > 0) {
      this.servicesList = value;
    }
  }
  @Input() courrier: Mail | null = null;
  @Input() listToReloadDatas: boolean = false;
  @Input() rightMail: MeRightMail | null = null;

  @Output() recipients = new EventEmitter<MailDestinataire[]>();
  @Output() public mailModeEvent = new EventEmitter<string>();

  public items: MailDestinataire[] = [];
  public listOfActions: Action[] | null = null;
  public amountOfActions: MailDestinataire[] = [];
  public amountOfInfos: MailDestinataire[] = [];
  public servicePrincipal: MailDestinataire | null = null;
  public destiPrincipal: MailDestinataire | null = null;
  public destinataireInput: MailDestinataireInput | null = null;
  public activeLine: number = 0;
  public locale4Calendar: AssetsCalendarFr | null = null;
  public ref: DynamicDialogRef | null = null;
  public destinataires: MailRecipientDetailsDto[] = [];
  public servicesList: {
    label: string;
    value: number;
    parentId: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
    description: string;
    email: string;
  }[] = [];
  public currentWeek = moment().format('ww');
  public today = moment().format('DD/MM/YYYY');
  public userInfos: UserInfo | null = null;
  public actionStatus: ActionStatutDTO[] = [];
  public actionTypes: ActionTypesDTO[] | null = [];
  public listOfGroups: GroupsGlobalDto[] | null = [];
  public regexDate = /[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{4}/;
  public loadingDisplay: boolean = false;
  public columns: Cols[] = [
    {
      field: 'principal',
      header: 'courrier.main',
      format: (_item, value) => {
        return value.principal
          ? `<div class='d-block position-relative coreIcon'><i class="bi bi-star-fill"></i></div>`
          : `<div class='d-block position-relative coreIcon '><i class="bi bi-star"></i></div>`;
      },
      click: (item) => {
        if (this.rightMail?.distribution?.addService || this.rightMail?.distribution?.addUser) this.setPrincipal(item);
      },
    },
    {
      field: 'transmisDateLabel',
      header: 'courrier.transmissionDate',
      format: (_item, value) => {
        if (value?.transmisDate) {
          return `<span class="${value.traiteLe !== null ? 'text-info' : ''}">${moment(value.transmisDate).format(
            'DD/MM/YYYY'
          )} ${value.statut ? '(' + value.statut + ')' : ''}</span>`;
        } else {
          return '/';
        }
      },
      sort: (a, b, order) => {
        //Comme on retourne un span,... il faut réussir a récupérer les dates des objets
        let dateA = a.match(this.regexDate);
        let dateB = b.match(this.regexDate);
        dateA ? (dateA = dateA[0]) : null; //S'il y'a une dateA c'est qu'on a matché sur la date => on va récupérer en élément 0 pour n'avoir que le match de la date. S'il n'y a rien, alors y'a pas de date
        dateB ? (dateB = dateB[0]) : null;
        const val1 = moment(dateA, 'DD/MM/YYYY').isValid() ? moment(dateA, 'DD/MM/YYYY').unix() : null;
        const val2 = moment(dateB, 'DD/MM/YYYY').isValid() ? moment(dateB, 'DD/MM/YYYY').unix() : null;
        if (val1 === null) return 1;
        else if (val2 === null) return -1;
        else return val1 < val2 ? 1 * order : -1 * order;
      },
      sortable: true,
    },
    {
      field: 'echeanceLabel',
      header: 'courrier.dueDate',
      format: (value, item) => {
        if (value) {
          if (item.traiteLe === null) {
            const transmissionDate = moment(value).format('ww');
            if (transmissionDate === this.currentWeek) {
              return "<span class='text-success'>" + moment(value).format('DD/MM/YYYY') + '</span>';
            } else if (transmissionDate < this.currentWeek) {
              return "<span class='text-danger'>" + moment(value).format('DD/MM/YYYY') + '</span>';
            }
          } else {
            return "<span class='text-info'>" + moment(value).format('DD/MM/YYYY') + '</span>';
          }
        } else {
          return '/';
        }
      },
      tooltip: (value) => {
        if (value.echeance) {
          const transmissionDate = moment(value.echeance).format('ww');
          if (transmissionDate === this.currentWeek) {
            return 'Cette semaine';
          } else if (transmissionDate < this.currentWeek) {
            return 'En retard';
          }
        } else {
          return '/';
        }
      },
      sort: (a, b, order) => {
        //Comme on retourne un span,... il faut réussir a récupérer les dates des objets
        let dateA = a.match(this.regexDate);
        let dateB = b.match(this.regexDate);
        dateA ? (dateA = dateA[0]) : null; //S'il y'a une dateA c'est qu'on a matché sur la date => on va récupérer en élément 0 pour n'avoir que le match de la date. S'il n'y a rien, alors y'a pas de date
        dateB ? (dateB = dateB[0]) : null;
        const val1 = moment(dateA, 'DD/MM/YYYY').isValid() ? moment(dateA, 'DD/MM/YYYY').unix() : null;
        const val2 = moment(dateB, 'DD/MM/YYYY').isValid() ? moment(dateB, 'DD/MM/YYYY').unix() : null;
        if (val1 === null) return 1;
        else if (val2 === null) return -1;
        else return val1 < val2 ? 1 * order : -1 * order;
      },
      sortable: true,
    },
    {
      field: 'transmissionUserName',
      header: 'courrier.requester',
      format: (item, value) => {
        if (item || value.transmissionUserId) {
          return item ? item : value.transmissionUserId;
        } else if (!item && !value.transmissionUserId) {
          return '/';
        }
      },
      tooltip: (value) => {
        if (value && value.transmissionUserId) {
          return `${value.transmissionUserName}
          Type : ${value.transmissionUserType}
          Adresse : ${value.transmissionUserAdress}`;
        }
      },
    },
    {
      field: 'name',
      header: 'courrier.recipient',
      format: (_item, value) => {
        if (value.type === 'DESTINATAIRE') {
          return `<span class="${value.traiteLe !== null ? 'text-info' : ''}">${value.nom ? value.nom + ' ' + (value.prenom ? value.prenom : '') : value.libre
            } ${value.type === 'DESTINATAIRE' && value.libre ? '(' + value.type + ' LIBRE)' : '(' + value.type + ')'}</span>`;
        } else if (value.type === 'SERVICE') {
          return value.name + ' (SERVICE)';
        } else if (value.type === 'GROUPE') {
          return value.name + ' (GROUPE)';
        } else {
          return '/';
        }
      },
    },
    {
      field: 'isActionOrInfo',
      header: 'courrier.type',
      format: (_item, value) => {
        if (value.action === null) {
          return 'Pour info';
        } else return 'Action';
      },
    },
    {
      field: 'messageLabel',
      header: 'courrier.message',
      format: (_item, value) => {
        if (value && value.message) {
          return `<span class="${value.traiteLe !== null ? 'text-info' : ''}">${value.message}</span>`;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'actione',
      header: 'courrier.actionType',
      format: (_item, value) => {
        if (value && value.action) {
          return `<span class="${value.traiteLe !== null ? 'text-info' : ''}">${value.action}</span>`;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'responseLabel',
      header: 'courrier.answer',
      format: (_item, value) => {
        if (value?.reponse) {
          return `<span class="${value.traiteLe !== null ? 'text-info' : ''}">${value.reponse}</span>`;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'actionss',
      header: 'courrier.reply',
      sortable: false,
      format: (_value, item) => {
        if (item?.rights.canReply) {
          return `<div class="btn btn-primary d-block w-100">Traiter</div>`;
        } else return '/';
      },
      click: (column) => {
        if (column.rights.canReply) {
          this.answerToAction(column);
        }
      },
    },
  ];

  public appConfig: ConfigDto | null = null;

  constructor(
    private dataService: DataService,
    public dialogService: DialogService,
    private toastr: ToastrService,
    public confirmationService: ConfirmationService,
    private translationService: TranslationService,
    private spinner: NgxSpinnerService,
    public router: Router,
    public translater: TranslateService,
    private usersService: UsersService,
    private contactsService: ContactsService,
    private contactsGlobalService: ContactsGlobalService,
    private actionsService: ActionsService,
    private recipientsService: RecipientsService,
    private configService: ConfigService,
    private mailsRightsService: MailsRightsService,
    private groupsService: GroupsService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.courrier?.currentValue) {
      this.courrier = changes.courrier.currentValue;
      this.setDatas();
    } else if (changes.listToReloadDatas?.currentValue) {
      this.setDatas();
    }
  }

  setDatas(): void {
    this.items = [];
    this.setTranslations();
    this.getLocale4Calendar();

    forkJoin({
      config: this.configService.fetchConfig().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors de la récupération des paramètres globaux de configuration');
          return of(null);
        })
      ),
      actionStatus: this.actionsService.getAllActionsStatutes().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error(this.translater.translate('courrier.statusListLoadError'));
          return of<ActionStatutDTO[]>([]);
        })
      ),
      actionTypes: this.actionsService.getAllActionsTypes().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error(this.translater.translate('courrier.typeListLoadError'));
          return of(null);
        })
      ),
      groups: this.groupsService.fetchGlobalGroups().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error(this.translater.translate('error.errorOccurredWhileRetrievingGroups'));
          return of(null);
        })
      ),
    }).subscribe((value) => {
      this.appConfig = value.config;
      this.actionStatus = value.actionStatus.filter((item) => item.notUsed === false && item.description);
      this.actionTypes = value.actionTypes;
      this.listOfGroups = value.groups;
      this.getMailDestinataires().then(() => {
        this.checkIfItemIsAlone();
        if (sessionStorage.getItem('showDestinataireModal') === '1') {
          sessionStorage.removeItem('showDestinataireModal');
          setTimeout(() => {
            this.transfer();
          }, 1000);
        }
      });
    });
  }

  setTranslations(): void {
    this.columns.map((column) => {
      column.header = this.translater.translate(column.header);
    });
  }

  /**
   * Open the recipient modal and call the add recipient method
   */

  /**
   * Method to add one or multiple recipients to the current courrier
   * @param newDestArray array of destinataire
   */
  public addDestinataires(data: RecipientModalOnCloseDatas): void {
    if (data) {
      this.spinner.show();
      this.addFreeRecipients(data.freeRecipientArray).then(() => {
        const hasOtherRecipients =
          data.contactArray?.length > 0 ||
          data.usersArray?.length > 0 ||
          data.serviceArray?.length > 0 ||
          data.groupsArray?.length > 0;

        if (!hasOtherRecipients) {
          this.spinner.hide();
          this.toastr.success(this.translater.translate('courrier.recipientAdded'));
          this.getMailDestinataires();
          if (sessionStorage.getItem('showModalDocument') === '1') {
            this.openDocument();
          }
          return;
        }

        const listOfDatas = {
          libre: null,
          contacts: [
            ...data.contactArray.map((item) => ({
              contactId: item.value,
              historiqueDescription: item.label,
            })),
            ...data.usersArray.map((item) => ({
              contactIdiAdmin: item.value,
              historiqueDescription: item.label,
            })),
          ],
          serviceIds: data.serviceArray.map((item) => item.value),
          groupeIds: data.groupsArray.map((item) => item.id),
        };
        this.recipientsService.addMailsDestinataires(this.courrier!.id, listOfDatas).subscribe({
          next: () => {
            this.toastr.success(this.translater.translate('courrier.recipientAdded'));
            this.spinner.hide();
            this.getMailDestinataires();
            if (sessionStorage.getItem('showModalDocument') === '1') {
              this.openDocument();
            }
          },
        });
      });
    }
  }

  private addFreeRecipients(
    freeRecipientArray: { id: string; name: string }[]
  ): Promise<boolean> {
    return new Promise((resolve) => {
      if (!freeRecipientArray?.length) return resolve(true);
      async.eachSeries(
        freeRecipientArray,
        (item, next) => {
          const destinataireInput = {
            libre: item.name,
            contacts: [],
            serviceIds: [],
            groupeIds: [],
          };
          this.recipientsService.addMailsDestinataires(this.courrier.id, destinataireInput).subscribe({
            next: () => next(),
            error: (error) => {
              console.error('Error : ', error);
              this.toastr.error("Erreur lors de l'ajout de : " + destinataireInput.libre);
              next();
            },
          });
        },
        () => resolve(true)
      );
    });
  }

  /**
   * The method retreive recipients of this courrier
   */
  public getMailDestinataires(): Promise<boolean> {
    return new Promise((resolve) => {
      this.loadingDisplay = true;
      this.items = [];
      GetMailRecipientsUtils.getMailRecipients(
        this.courrier.id,
        this.servicesList,
        this.recipientsService,
        this.contactsService,
        this.contactsGlobalService,
        this.listOfGroups,
        this.usersService,
        true
      ).subscribe({
        next: (response) => {
          if (response.error) {
            this.spinner.hide();
            this.toastr.error(this.translater.translate(response.error));
          } else {
            this.destinataires = response.recipientsFromQuery;
            let temp = [];
            temp = response.freeList.concat(response.userList, response.serviceList, response.groupList);
            this.items = _.chain(temp).sortBy('id').sortBy('echeanceDateOrderUnix').value().reverse();

            this.listOfActions = this.items
              .filter((item) => item.action)
              .map((item) => {
                return {
                  action: item,
                };
              });

            if (this.items.length > 0) {
              this.recipients.emit(this.items);
            }
            this.amountOfActions = this.items.filter((action) => {
              return action.action !== null;
            });
            this.amountOfActions = _.uniq(this.amountOfActions, 'id');
            this.amountOfInfos = this.items.filter((action) => {
              return action.action === null;
            });
            this.amountOfInfos = _.uniq(this.amountOfInfos, 'id');
            this.loadingDisplay = false;
            resolve(true);
          }
        },
      });
    });
  }

  getOppositeColor(bgColor): string {
    if (bgColor) {
      const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      const r = parseInt(color.substring(0, 2), 16); // hexToR
      const g = parseInt(color.substring(2, 4), 16); // hexToG
      const b = parseInt(color.substring(4, 6), 16); // hexToB
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    } else {
      return '#000000';
    }
  }

  /**
   * Method that will get all the translations needed for calendar component
   * Change "fr" with the suitable langage if needed
   */
  public getLocale4Calendar(): void {
    this.translationService.getCalendartranslate(localStorage.getItem('lang')).subscribe({
      next: (response) => {
        this.locale4Calendar = response;
      },
    });
  }

  /**
   * Method check the type avec the recipient in param and set it to principal recipient of this courrier
   * @param newPrincipal recipient to set prinicpal
   */
  setPrincipal(newPrincipal?, callGetDestinataires = true): void {
    if (newPrincipal) {
      let destInput;

      if (newPrincipal.type === 'DESTINATAIRE') {
        this.destiPrincipal = newPrincipal;
        destInput = new MailDestinatairePInput({
          type: this.destiPrincipal.type,
          destinataireId: this.destiPrincipal.id,
        });
      } else if (newPrincipal.type === 'SERVICE') {
        this.servicePrincipal = newPrincipal;
        destInput = new MailDestinatairePInput({
          type: this.servicePrincipal.type,
          destinataireId: this.servicePrincipal.id,
        });
      }

      this.recipientsService.setDestinatairePrincipal(this.courrier.id, destInput).subscribe({
        next: () => {
          this.toastr.success(
            this.translater.translate(newPrincipal.type === 'DESTINATAIRE' ? 'courrier.mainRecipientReplaced' : 'courrier.mainServiceReplaced')
          );
          callGetDestinataires ? this.getMailDestinataires() : null;
        },
        error: (error) => {
          console.error(error);
          this.toastr.error(
            this.translater.translate(
              newPrincipal.type === 'DESTINATAIRE' ? 'courrier.mainRecipientReplaceError' : 'courrier.mainServiceReplaceError'
            )
          );
        },
      });
    }
  }

  deleteMultiple(items: MailDestinataire[]): void {
    if (items.length === 0) return;

    this.mailsRightsService.getRightsMailByID(this.courrier.id).subscribe({
      next: (res) => {
        this.rightMail = res;

        const itemsToDelete: MailDestinataire[] = [];

        items.forEach((item) => {
          const isAllowed =
            item.type === 'SERVICE'
              ? this.rightMail.distribution.deleteService
              : this.rightMail.distribution.deleteUser.some((x) => x.mailDestinataireId === item.id && x.delete === true);

          if (!isAllowed) {
            this.toastr.warning(this.translater.translate('courrier.noPermissionToDeleteRecipient'));
            return;
          }

          itemsToDelete.push(item);
        });

        if (itemsToDelete.length === 0) {
          this.recipients.emit(this.items);
          this.getMailDestinataires();
          return;
        }

        const data: MailRecipientDeleteDTO = {
          destinataires: itemsToDelete.map((item) => ({
            id: item.id ? item.id : item.contactId,
            contactName: item.libre ? item.libre : (item.prenom ? item.prenom : '') + ' ' + (item.nom ? item.nom : ''),
          })),
        };

        this.recipientsService.deleteMailsDestinataires(this.courrier.id, data).subscribe({
          next: () => {
            this.toastr.success(this.translater.translate('courrier.recipientDeleted'));
            this.removeDeletedItems(itemsToDelete);
            this.recipients.emit(this.items);
            this.getMailDestinataires();
          },
          error: (error) => {
            console.error(error);
            this.toastr.error(this.translater.translate('courrier.recipientDeleteError'));
            this.recipients.emit(this.items);
            this.getMailDestinataires();
          },
        });
      },
    });
  }

  private removeDeletedItems(deletedItems: MailDestinataire[]): void {
    deletedItems.forEach((item) => {
      const indexToDelete = this.items.findIndex((x) => x.id === item.id);
      if (indexToDelete !== -1) {
        this.items.splice(indexToDelete, 1);
      }
      if (item.principal) {
        if (item.type === 'SERVICE') {
          this.servicePrincipal = null;
        } else {
          this.destiPrincipal = null;
        }
      }
    });

    this.amountOfActions = this.items.filter((action) => {
      action.action !== null;
    });
    this.amountOfActions = _.uniq(this.amountOfActions, 'id');
    this.amountOfInfos = this.items.filter((action) => {
      action.action === null;
    });
    this.amountOfInfos = _.uniq(this.amountOfInfos, 'id');

    if (deletedItems.some((item) => item.principal)) {
      const hasAlreadyPrincipal = this.items.filter((x) => x.principal === true);
      if (hasAlreadyPrincipal.length === 0) {
        this.toastr.warning(this.translater.translate('courrier.noMainRecipientWarning'));
      }
    }
  }

  /**
   * Verify if there are principal recipient and set it if not
   */
  checkIfItemIsAlone(): void {
    if (this.items.length === 1 && (this.rightMail?.distribution?.addService || this.rightMail?.distribution?.addUser)) {
      this.setPrincipal(this.items[0], false);
    }
  }

  /**
   * Method check if the new recipient aren't already in the destinataire list
   * @param arrayToVerify array of MailDestinataire
   * return array of new recipient
   */
  checkDuplicate(arrayToVerify): void {
    this.items.map((item) => {
      arrayToVerify.map((nDest) => {
        item.type = item['isAction'] ? 'ACTION' : 'DESTINATAIRE';
        if (nDest.libre === null || !nDest.libre) {
          if (item.contactId === nDest.contactId && item.type === nDest.type) {
            const indexToDelete = _.indexOf(arrayToVerify, nDest);
            arrayToVerify.splice(indexToDelete, 1);
          }
        } else {
          if (item.libre === nDest.libre) {
            const indexToDelete = _.indexOf(arrayToVerify, nDest);
            arrayToVerify.splice(indexToDelete, 1);
          }
        }
      });
    });
    return arrayToVerify;
  }

  public comparer(otherArray) {
    return function (current) {
      return (
        otherArray.filter(function (other) {
          return other.contactId == current.contactId;
        }).length == 0
      );
    };
  }

  /**
   * Method check if selected user are already in the list
   * @param member to verify
   * return false if in the list , true if not
   */
  public alreadyInList(member): boolean {
    this.items.map((item) => {
      if (item.contactId === member.contact.id) {
        return false;
      }
    });
    return true;
  }

  answerToAction(event): void {
    const column = event.action;
    const action = {
      action: column,
      mailId: column.mailId,
      objet: this.courrier.objet,
    };
    // Building dropdown  (label - value)
    const status = [];
    this.actionStatus.map((s) => {
      status.push({
        label: s.description,
        value: s.description,
        id: s.id,
        ordreAffichage: s.ordreAffichage,
      });
    });

    const ref = this.dialogService.open(ActionResponseModalComponent, {
      dismissableMask: true,
      closable: true,
      header: 'Envoyer une réponse',
      width: '70vw',
      baseZIndex: 1000,
      data: {
        appConfig: this.appConfig,
        currentAction: action,
        status: status,
        accuseDeReponse: column.accuseDeReponse,
      },
    });

    ref.onClose.subscribe({
      next: (value: { replySuccess: boolean; isFromFlowAndProcessed?: boolean }) => {
        if (value.isFromFlowAndProcessed) {
          this.dataService.setRefreshList(true);
        } else if (value.replySuccess) {
          this.setDatas();
        }
      },
    });
  }

  createAction(): void {
    const ref = this.dialogService.open(ActionCreateModalComponent, {
      dismissableMask: false,
      header: 'Créer une action',
      closable: false,
      baseZIndex: 1000,
      width: '70vw',
      data: {
        currentCourrier: this.courrier,
      },
    });

    ref.onClose.subscribe({
      next: (value) => {
        value ? this.setDatas() : '';
      },
    });
  }

  openDocument(): void {
    sessionStorage.removeItem('showModalDocument');
    const ref = this.dialogService.open(CModeChoiceModalComponent, {
      dismissableMask: false,
      width: '60vw',
      header: 'Type de document',
      baseZIndex: 1000,
      data: {
        newMail: this.courrier,
        modeAnswer: false,
        mailId: this.courrier.id,
      },
    });
    ref.onClose.subscribe({
      next: (value) => {
        switch (value) {
          case 'mailNoModel':
            // KEEP THE EMIT For courrierEditionForm
            this.mailModeEvent.emit('mailNoModel');
            this.router.navigate(['/private/ic/new/' + this.courrier.id, { mode: value }]);
            break;
          case 'mailModel':
            // KEEP THE EMIT For courrierEditionForm
            this.mailModeEvent.emit('mailModel');
            this.router.navigate(['/private/ic/new/' + this.courrier.id, { mode: value }]);
            break;
        }
      },
    });
  }

  transfer(): void {
    this.spinner.hide();
    const ref = this.dialogService.open(RecipientModalComponent, {
      closable: false,
      showHeader: false,
      dismissableMask: false,
      width: '60vw',
      baseZIndex: 1000,
      data: {
        courrierID: this.courrier.id,
      },
    });
    ref.onClose.subscribe({
      next: (data: RecipientModalOnCloseDatas) => {
        if (data) {
          let arrayIDToCheck = [];
          const remplacantArray = [];
          async.waterfall(
            [
              (cb) => {
                if (data.contactArray.length > 0) {
                  data.contactArray.map((item) => {
                    arrayIDToCheck.push(item.value);
                  });
                  cb(null);
                } else {
                  arrayIDToCheck = [];
                  cb(null);
                }
              },
              (cb) => {
                if (arrayIDToCheck && arrayIDToCheck.length > 0) {
                  this.contactsService.fetchContactsRemplacantsiCourrier(arrayIDToCheck).subscribe({
                    next: (res) => {
                      const hasAbsentPeopleArray = [];
                      if (res?.length > 0) {
                        res.map((remplacant) => {
                          data.contactArray.map((dest) => {
                            if (remplacant.absent === true && dest.value === remplacant.contactId) {
                              hasAbsentPeopleArray.push(remplacant);
                            }
                          });
                        });
                      }
                      if (hasAbsentPeopleArray.length > 0) {
                        this.confirmationService.confirm({
                          message: this.translater.translate('courrier.replaceAutoForAbsentees'),
                          key: 'remplacantCourrierCreateRecipients',
                          accept: () => {
                            res.map((item) => {
                              if (item.absent) {
                                data.contactArray.map((dest) => {
                                  if (dest.value === item.contactId) {
                                    this.contactsService.fetchContact(item.remplaceParContactId, 'iAdmin').subscribe({
                                      next: (res: ContactDto) => {
                                        if (res) {
                                          remplacantArray.push(
                                            dest,
                                            new Contact({
                                              value: item.remplaceParContactId,
                                              name: (res.prenom ? res.prenom : '') + ' ' + (res.nom ? res.nom : ''),
                                              label: (res.prenom ? res.prenom : '') + ' ' + (res.nom ? res.nom : ''),
                                              type: 'DESTINATAIRE',
                                              lastname: res.prenom ? res.prenom : '',
                                              nom: res.nom ? res.nom : '',
                                              prenom: res.prenom ? res.prenom : '',
                                            })
                                          );
                                        }
                                      },
                                    });
                                  } else {
                                    remplacantArray.push(dest);
                                  }
                                });
                              }
                            });
                            setTimeout(() => {
                              cb(null);
                            }, 1000);
                          },
                          reject: () => {
                            cb(null);
                          },
                        });
                      } else {
                        cb(null);
                      }
                    },
                  });
                } else {
                  cb(null);
                }
              },
              (cb) => {
                if (remplacantArray.length > 0) {
                  data.contactArray = remplacantArray;
                  cb(null);
                } else {
                  cb(null);
                }
              },
            ],
            () => {
              setTimeout(() => {
                this.addDestinataires(data);
              }, 500);
            }
          );
        }
      },
    });
  }
}
